import React, { useState } from "react";
import api from "../../../../../services/api";
import { Faq } from "../../../../../global/types";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "@mui/material";
import { MdExpandMore } from "react-icons/md";
import FaqsSkeleton from "./Skeleton/FaqsSkeleton";
import { ArticleWrapper, Wrapper } from "./styles";

function FaqsTab() {
  const [loading, setLoading] = useState(true);
  const [faqs, setFaqs] = useState<Faq[]>();

  React.useEffect(() => {
    const loadApi = async () => {
      try {
        setLoading(true);
        const response = await api.get("/api/client/faq");

        if (Array.isArray(response.data.data.data)) {
          setFaqs(response.data.data.data.slice(0, 7));
        } else {
          setFaqs([]); 
        }
      } catch (err) {
        console.log(err);
        setFaqs([]); 
      }
      setLoading(false);
    };
    loadApi();
  }, []);

  let content = <FaqsSkeleton />;

  if (!loading) {
    if (faqs && faqs.length > 0) {
      content = (
        <Wrapper>
          {faqs.map((faq) => (
            <Accordion key={faq.id}>
              <AccordionSummary expandIcon={<MdExpandMore />}>
                {faq.title}
              </AccordionSummary>
              <AccordionDetails>
                <ArticleWrapper
                  dangerouslySetInnerHTML={{ __html: faq.article }}
                />
              </AccordionDetails>
            </Accordion>
          ))}
        </Wrapper>
      );
    } else {
      content = <Wrapper>Nenhuma pergunta frequente encontrada.</Wrapper>;
    }
  }

  return content;
}

export default FaqsTab;
